import {
  ANALYTICS_GET_REPORTS,
  ANALYTICS_LOOKER_URL,
  ANALYTICS_IFRAME_LOOK_URL,
} from '../constants/endpoints';
import {
  LOAD_ANALYTICS_REPORTS,
  LOAD_LOOKER_URL,
  LOAD_IFRAME_LOOK_URL,
} from '../constants/actions';

import { apiCall } from './api';

export const getLookerUrl = (dashboardName, timezone, locale) => {
  const args = {
    endpoint: ANALYTICS_LOOKER_URL(dashboardName, timezone, locale),
    method: 'GET',
    action: LOAD_LOOKER_URL,
    process: ({ body }) => body,
  };
  return apiCall({ args });
};

export const getiFrameLookUrl = (caseId, lookNumber, timezone) => {
  const args = {
    endpoint: ANALYTICS_IFRAME_LOOK_URL(caseId, lookNumber, timezone),
    method: 'GET',
    action: LOAD_IFRAME_LOOK_URL,
    process: ({ body }) => body,
  };
  return apiCall({ args });
};

export const loadReports = () => (dispatch, getStore) => {
  const organization = getStore()?.auth?.user?.ownerOrganization?.name || '';
  const args = {
    endpoint: ANALYTICS_GET_REPORTS(organization.replace(/\//g, ' ')),
    method: 'GET',
    process: ({ body }) => body,
    action: LOAD_ANALYTICS_REPORTS,
  };
  return apiCall({ args })(dispatch, getStore);
};
